import { Building2 } from "lucide-react";
import { useTenant } from "@/contexts/TenantContext";
import { Label } from "@/components/ui/label";

// Reports always use the active branch from the header (no "all branches" view).
export function BranchFilter() {
  const { activeBranch } = useTenant();
  return (
    <div data-testid="branch-filter">
      <Label className="text-[11px] uppercase tracking-wider text-muted-foreground">Sucursal</Label>
      <div
        className="h-9 w-56 px-3 flex items-center gap-2 rounded-md border border-border bg-muted/40 text-sm"
        title="Cambia la sucursal desde el selector del encabezado"
        data-testid="branch-filter-active"
      >
        <Building2 className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="truncate">{activeBranch?.name || "Sucursal activa"}</span>
      </div>
    </div>
  );
}
